import React from "react";
import { FaShieldAlt, FaCheck } from "react-icons/fa";
import Expert from "../Images/why_expertise.png";
import Expert1 from "../Images/why_personalized.png";
import Expert2 from "../Images/why_technology.png";
import Expert3 from "../Images/why_compliance.png";
import Expert4 from "../Images/why_strategy.png";
import Expert5 from "../Images/why_risk.png";

function WhyChooseUs() {
  const cards = [
    {
      img: Expert,
      title: "Expertise",
      desc: "Our team comprises seasoned tax professionals certified and knowledgeable Experts with in-depth knowledge of tax laws, regulations, and a proven track record of delivering accurate and reliable financial services."
    },
    {
      img: Expert1,
      title: "Personalized Approach",
      desc: "We understand that every business is unique. That's why we take the time to understand your specific requirements and craft customized solutions to address your financial challenges."
    },
    {
      img: Expert2,
      title: "Technology Integration",
      desc: "Embracing cutting-edge accounting technologies, we ensure efficiency, accuracy, and security in handling your financial data."
    },
    {
      img: Expert3,
      title: "Compliance Assurance",
      desc: "Stay ahead of regulatory changes and tax obligations with our expert guidance, ensuring that your business remains in full compliance with applicable laws."
    },
    {
      img: Expert4,
      title: "Strategic Planning",
      desc: "Beyond compliance, we focus on strategic tax planning to help you make informed financial decisions and optimize your tax position."
    },
    {
      img: Expert5,
      title: "Risk Mitigation",
      desc: "We focus on proactive risk management, helping businesses identify and address potential compliance issues before they escalate."
    }
  ];

  return (
    <section className="why-choose-exact">
      {/* BACKGROUND ELEMENTS */}
      <div className="bg-wave-top-left"></div>
      <div className="bg-dots-top-right"></div>
      <div className="bg-globe"></div>
      <div className="bg-wave-bottom-back"></div>
      <div className="bg-wave-bottom-front"></div>

      <div className="container position-relative z-2">

        {/* HEADING SECTION */}
        <div className="heading-wrapper text-center">
          <div className="pill-badge">
            <div className="badge-icon">
              <FaShieldAlt />
              <FaCheck className="badge-check" />
            </div>
            <span>Why Choose</span>
          </div>

          <h2 className="main-heading">
            <span className="text-dark-blue">Compliance</span>
            <span className="text-bright-blue">Kare</span>
          </h2>

          <p className="sub-desc">
            Smart, reliable and hassle-free tax solutions for individuals, businesses and organizations.
          </p>

          <div className="gradient-dash"></div>
        </div>

        {/* CARDS GRID */}
        <div className="row g-4 justify-content-center">
          {cards.map((card, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="why-card-modern">
                <div className="card-top-right-swoop"></div>
                <img src={card.img} alt="" className="why-icon" />
                <h4>{card.title}</h4>
                <p>{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
        .why-choose-exact {
          background: #f4f8fd; /* Light blue background */
          padding: 80px 0 100px 0;
          position: relative;
          overflow: hidden;
          font-family: 'Inter', sans-serif;
        }

        /* BACKGROUND ELEMENTS */
        .bg-wave-top-left {
          position: absolute;
          top: -10%;
          left: -5%;
          width: 35%;
          height: 35%;
          background: linear-gradient(135deg, #165986 0%, #0ea5e9 100%);
          border-radius: 0 0 100% 0;
          opacity: 0.9;
          z-index: 1;
        }
        
        .bg-wave-top-left::after {
           content: '';
           position: absolute;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           background: rgba(255,255,255,0.1);
           border-radius: 0 0 100% 0;
           transform: scale(1.1) translateX(10px) translateY(10px);
           z-index: -1;
        }

        .bg-dots-top-right {
          position: absolute;
          top: 30px;
          right: 50px;
          width: 250px;
          height: 150px;
          background-image: radial-gradient(#cbd5e1 2px, transparent 2px);
          background-size: 20px 20px;
          opacity: 0.6;
          z-index: 1;
        }

        .bg-globe {
          position: absolute;
          top: -50px;
          left: -50px;
          width: 400px;
          height: 400px;
          border-radius: 50%;
          border: 1px solid rgba(29, 78, 216, 0.05);
          background: radial-gradient(circle, rgba(29, 78, 216, 0.03) 0%, transparent 70%);
          z-index: 0;
        }

        .bg-wave-bottom-back {
          position: absolute;
          bottom: 0;
          left: -10%;
          width: 120%;
          height: 12%;
          background: linear-gradient(90deg, #38bdf8 0%, #165986 100%);
          border-radius: 100% 100% 0 0 / 100% 100% 0 0;
          z-index: 1;
          opacity: 0.6;
        }

        .bg-wave-bottom-front {
          position: absolute;
          bottom: -5%;
          right: -5%;
          width: 60%;
          height: 15%;
          background: linear-gradient(270deg, #1e3a8a 0%, #165986 100%);
          border-radius: 100% 0 0 0;
          z-index: 2;
        }

        /* HEADING SECTION */
        .heading-wrapper {
          margin-bottom: 50px;
          position: relative;
          z-index: 3;
        }

        .pill-badge {
          display: inline-flex;
          align-items: center;
          background: #165986;
          color: #fff;
          padding: 6px 18px 6px 6px;
          border-radius: 30px;
          font-weight: 700;
          font-size: 14px;
          margin-bottom: 20px;
          box-shadow: 0 5px 15px rgba(29, 78, 216, 0.3);
        }

        .badge-icon {
          background: #fff;
          color: #165986;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          position: relative;
          font-size: 14px;
        }
        .badge-check {
          position: absolute;
          font-size: 7px;
          color: #fff;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .main-heading {
          font-size: 56px;
          font-weight: 900;
          margin-bottom: 15px;
          letter-spacing: -1px;
        }
        .text-dark-blue { color: #0f172a; }
        .text-bright-blue { color: #3e5c87ff; }

        .sub-desc {
          color: #475569;
          font-size: 18px;
          font-weight: 500;
          margin-bottom: 20px;
        }

        .gradient-dash {
          width: 60px;
          height: 5px;
          background: linear-gradient(90deg, #165986, #38bdf8);
          border-radius: 5px;
          margin: 0 auto;
        }

        /* CARDS GRID */
        .why-card-modern {
          background: #ffffff;
          border-radius: 20px;
          padding: 40px 30px 35px 30px;
          position: relative;
          overflow: hidden;
          text-align: center;
          height: 100%;
          border: 1.5px solid rgba(255,255,255,1);
          box-shadow: inset 0 3px 20px rgba(255,255,255,1), 0 15px 35px rgba(29, 78, 216, 0.08);
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .why-card-modern:hover {
          transform: translateY(-8px);
          box-shadow: inset 0 3px 20px rgba(255,255,255,1), 0 20px 45px rgba(29, 78, 216, 0.15);
        }

        /* Top Right Blue Swoop */
        .card-top-right-swoop {
          position: absolute;
          top: 0;
          right: 0;
          width: 90px;
          height: 90px;
          background: linear-gradient(225deg, #0ea5e9 0%, #165986 100%);
          border-bottom-left-radius: 100%;
          z-index: 0;
          opacity: 0.95;
          transition: all 0.3s ease;
        }
        
        .why-card-modern:hover .card-top-right-swoop {
          width: 100px;
          height: 100px;
        }

        .why-icon {
          width: 75px;
          height: 75px;
          object-fit: contain;
          margin-bottom: 25px;
          position: relative;
          z-index: 2;
          filter: drop-shadow(0 5px 10px rgba(29, 78, 216, 0.15));
          transition: transform 0.3s ease;
        }

        .why-card-modern:hover .why-icon {
          transform: scale(1.05);
        }

        .why-card-modern h4 {
          color: #0f172a;
          font-weight: 800;
          font-size: 22px;
          margin-bottom: 15px;
          position: relative;
          z-index: 2;
        }

        .why-card-modern p {
          color: #64748b;
          font-size: 14.5px;
          line-height: 1.6;
          margin: 0;
          position: relative;
          z-index: 2;
        }

        /* RESPONSIVE */
        @media (max-width: 992px) {
          .main-heading { font-size: 42px; }
          .bg-wave-top-left { width: 50%; height: 30%; }
        }

        @media (max-width: 768px) {
          .main-heading { font-size: 32px; }
          .sub-desc { font-size: 15px; padding: 0 10px; }
          .why-choose-exact { padding: 50px 0 60px 0; }
          .why-card-modern { padding: 30px 20px 25px 20px; }
          .why-card-modern h4 { font-size: 20px; }
          .why-card-modern p { font-size: 13.5px; }
          .pill-badge { font-size: 13px; padding: 5px 15px 5px 5px; margin-bottom: 15px; }
          .badge-icon { width: 22px; height: 22px; font-size: 12px; }
          .bg-globe { width: 250px; height: 250px; top: -30px; left: -30px; }
          .bg-wave-bottom-back { height: 15%; }
          .bg-wave-bottom-front { height: 20%; width: 100%; right: -20%; }
          .card-top-right-swoop { width: 70px; height: 70px; }
        }

        @media (max-width: 480px) {
          .main-heading { font-size: 28px; }
          .bg-wave-top-left { width: 70%; height: 20%; }
          .why-card-modern { padding: 25px 15px; border-radius: 15px; }
        }
        `
      }} />
    </section>
  );
}

export default WhyChooseUs;